import { sessionUserSchema, type LoginInput, type SessionUser } from '@ai-sales/shared'
import { z } from 'zod'
import { apiRequest } from '../lib/api-client.js'

export async function fetchMe(): Promise<SessionUser> {
  return apiRequest('/auth/me', sessionUserSchema)
}

export async function login(input: LoginInput): Promise<SessionUser> {
  return apiRequest('/auth/login', sessionUserSchema, { method: 'POST', body: input })
}

export async function logout(): Promise<void> {
  await apiRequest('/auth/logout', z.object({ ok: z.literal(true) }), { method: 'POST' })
}
